import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CanActivateFn, Router, RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MessagesModule } from 'primeng/messages';
import { PasswordModule } from 'primeng/password';
import { TooltipModule } from 'primeng/tooltip';
import { DirectiveModule } from '@Directive/directive.module';

import { AuthenticationComponent } from './authentication.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NewPasswordRequiredComponent } from '../authentication/new-password-required/new-password-required.component';
import { ComponentsModule } from 'app/main/apps/components/components.module';
import { RegisterComponent } from './register/register.component';
import { ConfigService } from 'app/app-config.service';
import { InputOtpComponent } from './components/input-otp/input-otp.component';
import { VerificationComponent } from './verification/verification.component';

const RegisterGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const configService = inject(ConfigService);
    if (!configService.getConfig.registerAllowed) return router.parseUrl('/auth/login');
    return true;
};

// routing
const routes: Routes = [
    {
        path: 'auth',
        component: AuthenticationComponent,
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            {
                path: 'login',
                component: LoginComponent,
                data: {
                    haslanguageMenu: true,
                },
            },
            {
                path: 'reset-password',
                component: ResetPasswordComponent,
                data: {
                    hasLanguageMenu: false,
                },
            },
            {
                path: 'forgot-password',
                component: ForgotPasswordComponent,
                data: {
                    hasLanguageMenu: false,
                },
            },
            {
                path: 'new-password-required',
                component: NewPasswordRequiredComponent,
            },
            {
                path: 'register',
                component: RegisterComponent,
                canActivate: [RegisterGuard],
                data: {
                    haslanguageMenu: true,
                },
            },
            {
                path: 'verification',
                component: VerificationComponent,
                data: {
                    hasLanguageMenu: true,
                },
            },
        ],
    },
];

@NgModule({
    declarations: [
        InputOtpComponent,
        AuthenticationComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        NewPasswordRequiredComponent,
        RegisterComponent,
        VerificationComponent,
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild(routes),
        TranslateModule,
        DirectiveModule,
        // PrimeNG Modules
        ButtonModule,
        CheckboxModule,
        DividerModule,
        DropdownModule,
        InputTextModule,
        KeyFilterModule,
        MessagesModule,
        PasswordModule,
        TooltipModule,
    ],
})
export class AuthenticationModule {}
